export default __webpack_public_path__ + "static/media/model-registerstep-new.233d31a1.png";